  import { Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { map, distinctUntilChanged, shareReplay, filter, tap, skip } from 'rxjs/operators';
import { NavigationUi } from '@app/constants';
import { ScreenService, ScrollService, PagesService, NavigationService } from '@app/data';
import { YTService } from './yt.service';
import { VimeoService } from './vimeo.service';

export interface Medium {
  showPlayer: boolean;
  id: string;
  provider: string;
  playVideo: boolean;
};

const defaultPlayer = {
  showPlayer: false,
  id: '',
  provider: '',
  playVideo: false
};

type ProviderSwitch = 'YouTube' | 'Vimeo';


@Injectable({
  providedIn: 'root'
})
export class PlayerService {

  public activeItem$ = this.screenService.activeItem$;
  public player$ = new BehaviorSubject<Medium[] | null | undefined>([]);
  private _navPlayer$ = new BehaviorSubject<any[]>([]);
  public navPlayer$: Observable<any> = this._navPlayer$.pipe(shareReplay({ bufferSize: 1, refCount: true }));
  public showPlayBtn$ = new BehaviorSubject(false);

  public playingVideoLink$ = new BehaviorSubject<any>({
    url: '',
    label: ''
  });

  private playerEvent$ = this.playerEvents.playerEvent$;
  private provider = { YouTube: this.ytService, Vimeo: this.vimeoService };
  private isInView$ = this.scroll.isInView$.pipe(distinctUntilChanged(),shareReplay({ bufferSize: 1, refCount: true }));
  private isPlaying$ = new BehaviorSubject(false);
  public isPlayingMini$ = new BehaviorSubject(false);
  public isPlayingOnPage$: Observable<boolean>;
  public isPlayingVideo$ = new BehaviorSubject<boolean>(false);
  private videoUrl = '';
  public showNavPlayer$: Observable<boolean>;
  private _showNavPlayer$ = new BehaviorSubject(false);
  //private page$ = this.activeItem$.pipe(filter((page: any) => page.length !== 0));
  private route$ = this.pages.route$;
  //private scrollToContent$;

	constructor(
    
    private playerEvents: PlayerEvents,
    private ytService: YTService,
    private vimeoService: VimeoService,
		private screenService: ScreenService,
    private pages: PagesService,
    private scroll: ScrollService,
    private navigation: NavigationService
	) {

    this.playerEvent$.subscribe(res => {
      //console.log('PlayerService playerEvent$ subscribe res ', res);

      switch (res) {
        case "loaded":
          const activeItem = this.screenService.getActiveItem()[0];
          //console.log('PlayerService playerEvent$ loaded activeItem',  activeItem);

          this.playingVideoLink$.next({
            url: activeItem.url,
            label: activeItem.title
          });
          
          break;
      }
          
      switch (res) {
        case "play":
          //const activeItem = this.screenService.getActiveItem()[0];
          
          //console.log('PlayerService playerEvent$ play activeItem',  activeItem);
          this.isPlayingVideo$.next(true);

          if (!this._showNavPlayer$.value) {
            /*this.playingVideoLink$.next({
              url: activeItem.url,
              label: activeItem.title
            });*/

            this.isPlaying$.next(true);
          }
          this.isPlayingMini$.next(true);
          break;          
      }

      switch (res) {
        case "pause":

          this.isPlayingVideo$.next(false);

          if (!this._showNavPlayer$.value) {
            //this.playingVideoLink$.next(false);
            this.isPlaying$.next(false);
          }
          else {
            this.isPlayingMini$.next(false);
          }
          
          break;  
      }
    });

    this.isPlayingOnPage$ = combineLatest(
      this.route$,
      this.isPlayingVideo$
    ).pipe(
      map(([route, isPlayingVideo]) => {
        return this.playingVideoLink$.value.url === route.url && isPlayingVideo;
      }),
      distinctUntilChanged(),
      shareReplay({ bufferSize: 1, refCount: true })
    );

    this.showNavPlayer$ = combineLatest(
      this.isInView$,
      this.isPlaying$,
      this.route$
    ).pipe(
      map(([isInView, isPlaying, route]) => {
        console.log('PlayerService showNavPlayer$ isInView',  isInView);
        //console.log('PlayerService showNavPlayer$ isPlaying',  isPlaying);
        //console.log('PlayerService showNavPlayer$ route',  route);
        console.log('PlayerService showNavPlayer$ this.playingVideoLink$.value',  this.playingVideoLink$.value);

        let showNavPlayer = false;

        if (this.playingVideoLink$.value !== '') {
          //const sameUrl = this.playingVideoLink$.value.url === route[0].path_page + route[0].url;
          const sameUrl = this.playingVideoLink$.value.url === route.url;
          showNavPlayer = ((sameUrl && !isInView) || !sameUrl) && isPlaying;
          const hideScreen = sameUrl && isPlaying;
          //const route = this.pages.getCurrentPage();

          console.log('PlayerService showNavPlayer$ showNavPlayer',  showNavPlayer);
          console.log('PlayerService showNavPlayer$ route.queryParams',  route.queryParams);

          if (hideScreen) {
            this.screenService.hideScreen();
          }

          this._showNavPlayer$.next(showNavPlayer);

          if (route.data && !route.data.detail  && !route.params.school && !route.data.subPage) {
            this.navigation.setHideNav(showNavPlayer);
          }
          else if (route.data && route.data.subPage && !route.queryParams.podstranka) {
            this.navigation.setHideNav(!isInView);
          }

          console.log('PlayerService showNavPlayer$ route.data && !route.data.detail  && !route.params.school && !route.data.subPage',  route.data && !route.data.detail  && !route.params.school && !route.data.subPage);
          console.log('PlayerService showNavPlayer$ route.data && route.data.subPage',  route.data && route.data.subPage);
        }

        /*if (!isInView) {
          this.scroll.setScrollIntoView(route.pageName);
        }*/
                
        //console.log('PlayerService skowNavPlayer$ !isInView && isPlaying',  !isInView && isPlaying);
        return showNavPlayer;
      }),
      distinctUntilChanged()
    );

    /* SCROLL */

    /*this.scrollToContent$ = combineLatest(
      this.route$,
      this.isInView$
    ).pipe(
      tap(_ => console.log('PlayerService showNavPlayer$ _',  _)),
      skip(2),
      tap(([route, isInView]) => {
        if (!isInView) {
          this.scroll.setScrollIntoView(route.pageName);
        }
      })
    );

    this.scrollToContent$.subscribe();*/
  }

	/* CONTROLS */

  public controlPlayer = (): void => {
    console.log('PlayerService controlPlayer this.player$.value',  this.player$.value);
    if (this.player$.value?.length === 0) {
      return;
    }
    const medium: any = this.player$.value ? this.player$.value[0] : false;
    const providerSwitch: ProviderSwitch = medium.provider;

    if (this.isPlayingMini$.value) {
      this.isPlayingMini$.next(false);
      this.provider[providerSwitch].pauseVideo();
    }
    else {
      this.isPlayingMini$.next(true);
      this.provider[providerSwitch].playVideo();

      if (this.playingVideoLink$.value.url === this.pages.getCurrentPage().url) {
        this.scroll.setScrollIntoView('top');
      }
    }
  }

  public loadScript = (medium: any) => {
    console.log('PlayerService loadScript medium',  medium);
    const providerSwitch: ProviderSwitch = medium.provider;
    
    this.provider[providerSwitch].loadScript(medium);
    this._navPlayer$.next([medium]);
  }

	public playVideo = (medium: any) => {
	  //console.log('PlayerService playVideo medium',  medium);

	  const player: Medium = {
      showPlayer: true,
      id: medium.field_video_id,
      provider: medium.field_video_platform === '9' ? 'YouTube' : 'Vimeo',
      playVideo: true
    };

    if (this.playingVideoLink$.value.url !== this.pages.getCurrentPage().url) {

      this.isPlaying$.next(false);
      this.screenService.hideScreen();
      this.player$.next([player]);
    }
	}

  public setScrollIntoView = (scrollTo: string): void  => this.scroll.setScrollIntoView(scrollTo);;
}

@Injectable({
  providedIn: 'root'
})
export class PlayerEvents {

  public playerEvent$ = new BehaviorSubject<string>('stoped');

  constructor() {}

  /* EVENTS */

  public playerEvent = (event: string) => {
    //console.log('PlayerEvents playerEvent event',  event);
    this.playerEvent$.next(event);
  };
}
